import React, { useEffect, useState, useCallback, useMemo } from "react";
import './TiketsDeGasolinaMain.scss';
import { Card } from 'primereact/card';
import { TabView, TabPanel } from 'primereact/tabview';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import { Message } from 'primereact/message';
import { Chip } from 'primereact/chip';
import { Divider } from 'primereact/divider';
import { Panel } from 'primereact/panel';
import { Checkbox } from 'primereact/checkbox';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ColorValidation, SubmitValidation, UpdateValue } from "../../../../utilidades/Validaciones";
import {
    buscarProveedorPeticion,
    getProveedores,
    getPurchaseOrder,
    subirInformacioCombustible
} from "../integracion";
import { formatearFecha, formateoDateATiempo, FormatoMoneda } from "../../../../utilidades/formateos";
import { agregarTicketFunction, getDataEditTiket, getGasolineras, subirInfoActualizada } from "./integracion";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { InputIcon } from "primereact/inputicon";
import { IconField } from "primereact/iconfield";

// ============================================================================
// CONSTANTES
// ============================================================================
const TIPO_COMBUSTIBLE_OPTIONS = [
    { name: "Magna", code: "Magna" },
    { name: "Diesel", code: "Diesel" },
    { name: "Premium", code: "Premium" }
];

const INITIAL_INPUT_LIST = {
    proveedor: { value: null, validationType: "empty" },
    fechaCaptura: { value: new Date(), validationType: "empty" },
    fechaInicio: { value: null, validationType: "empty" },
    fechaFinal: { value: null, validationType: "empty" },
    fechaCompra: { value: new Date(), validationType: "empty" },
    observaciones: { value: null, validationType: "empty" },
    ajusteDeCombustible: { value: 0, validationType: "empty" },
};

const INITIAL_PURCHASE_ORDER_LIST = {
    inicio: { value: new Date(), validationType: "empty" },
    fin: { value: new Date(), validationType: "empty" }
};

const INITIAL_EDITAR_TICKET = {
    fecha: { value: null, validationType: "empty" },
    hora: { value: null, validationType: "empty" },
    unidad: { value: null, validationType: "empty" },
    gasolinera: { value: null, validationType: "empty" },
    folio: { value: null, validationType: "empty" },
    kilometraje: { value: null, validationType: "empty" },
    tipoCombustible: { value: null, validationType: "empty" },
    litros: { value: null, validationType: "empty" },
    precio: { value: null, validationType: "empty" },
};

// ============================================================================
// UTILIDADES DE FECHA
// ============================================================================
const calcularLunesSemanaAnterior = (fecha = new Date()) => {
    const hoy = new Date(fecha);
    const diaSemana = hoy.getDay();
    const diferenciaDias = diaSemana === 0 ? 6 : diaSemana - 1;
    const lunesActual = new Date(hoy.getTime() - (diferenciaDias * 86400000));
    return new Date(lunesActual.getTime() - (7 * 86400000));
};

const calcularDomingoSemanaAnterior = (fechaLunes) => {
    return new Date(fechaLunes.getTime() + (7 * 86400000));
};

// ============================================================================
// UTILIDADES DE PAYLOAD
// ============================================================================
const construirPayloadTicket = (inputList) => ({
    fecha: formatearFecha(inputList.fecha.value),
    hora: formateoDateATiempo(inputList.hora.value),
    unidad: inputList.unidad.value,
    gasolinera: inputList.gasolinera.value?.code,
    folio: inputList.folio.value,
    kilometraje: inputList.kilometraje.value,
    tipoCombustible: inputList.tipoCombustible.value?.code,
    litros: inputList.litros.value,
    precio: inputList.precio.value,
});

// ============================================================================
// COMPONENTE PRINCIPAL
// ============================================================================
const TicketsDeGasolinaMain = () => {
    const navigate = useNavigate();

    // Estados principales
    const [inputList, setInputList] = useState(INITIAL_INPUT_LIST);
    const [inputListPurchaseOrder, setInputListPurchaseOrder] = useState(INITIAL_PURCHASE_ORDER_LIST);
    const [inputListEditarTiket, SetInputListEditarTiket] = useState(INITIAL_EDITAR_TICKET);
    const [inputListAgregarTiket, SetInputListAgregarTiket] = useState(INITIAL_EDITAR_TICKET);

    // Estados de UI
    const [activeTab, setActiveTab] = useState(0);
    const [openModalEdit, setOpenModalEdit] = useState(false);
    const [openModalAdd, setOpenModalAdd] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [purchaseFilter, setPurchaseFilter] = useState(null);

    // Estados de datos
    const [proveedores, setProveedores] = useState([]);
    const [gasolinerasOptions, setGasolinerasOptions] = useState([]);
    const [dataTable, setDataTable] = useState([]);
    const [purchaseDataTable, setPurchaseDataTable] = useState([]);
    const [archivoCargadoXML, setArchivoCargadoXML] = useState(null);

    // Estados de tickets
    const [idTiket, setIdTiket] = useState(null);
    const [Subtotal, setSubtotal] = useState(0);
    const [iva, setIva] = useState(0);
    const [totalMasAjuste, setTotalMasAjuste] = useState(0);
    const [activarBotonOdoo, setActivarBotonOdoo] = useState(false);
    const [ticketsXML, setTicketsXML] = useState(0);
    const [totalMatch, setTotalMatch] = useState(0);

    // Estados de carga
    const [isLoadingProveedores, setIsLoadingProveedores] = useState(false);
    const [isLoadingTickets, setIsLoadingTickets] = useState(false);
    const [isLoadingPurchaseOrders, setIsLoadingPurchaseOrders] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // ========================================================================
    // EFECTOS
    // ========================================================================

    // Cargar datos iniciales
    useEffect(() => {
        const cargarDatosIniciales = async () => {
            setIsLoadingProveedores(true);
            try {
                await Promise.all([
                    getProveedores(setProveedores),
                    getGasolineras(setGasolinerasOptions)
                ]);
            } catch (error) {
                console.error('Error al cargar datos iniciales:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al cargar los datos iniciales',
                });
            } finally {
                setIsLoadingProveedores(false);
            }
        };

        cargarDatosIniciales();
    }, []);

    // Calcular fechas automáticamente
    useEffect(() => {
        const fechaCaptura = inputList.fechaCaptura.value;
        if (!fechaCaptura) return;

        const lunesSemanaAnterior = calcularLunesSemanaAnterior(fechaCaptura);
        const domingoSemanaAnterior = calcularDomingoSemanaAnterior(lunesSemanaAnterior);

        setInputList(prev => ({
            ...prev,
            fechaInicio: { ...prev.fechaInicio, value: lunesSemanaAnterior },
            fechaFinal: { ...prev.fechaFinal, value: domingoSemanaAnterior }
        }));
    }, [inputList.fechaCaptura.value]);

    // Calcular total con ajuste
    useEffect(() => {
        const ajuste = parseFloat(inputList.ajusteDeCombustible.value) || 0;
        const subtotal = parseFloat(Subtotal) || 0;
        setTotalMasAjuste(subtotal + ajuste);
    }, [inputList.ajusteDeCombustible.value, Subtotal]);

    // Validación de colores
    useEffect(() => {
        Object.keys(inputList).forEach(nombrePropiedad => {
            const elemento = document.getElementById(nombrePropiedad);
            if (elemento) {
                ColorValidation(nombrePropiedad, inputList, "empty");
            }
        });
    }, [inputList]);

    // Cargar datos de ticket para editar
    useEffect(() => {
        if (!idTiket || !openModalEdit) return;

        const cargarDatosTicket = async () => {
            try {
                await getDataEditTiket(idTiket, SetInputListEditarTiket);
            } catch (error) {
                console.error('Error al cargar ticket:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al cargar los datos del ticket',
                });
            }
        };

        cargarDatosTicket();
    }, [idTiket, openModalEdit]);

    // ========================================================================
    // HANDLERS
    // ========================================================================

    const buscarProveedor = useCallback(async () => {
        if (!SubmitValidation(inputList, setInputList)) return;

        if (!archivoCargadoXML) {
            Swal.fire({
                icon: 'error',
                title: 'Archivo XML requerido',
                text: 'Por favor, seleccione el archivo XML antes de buscar tickets',
            });
            return;
        }

        setIsLoadingTickets(true);
        try {
            const response = await buscarProveedorPeticion({
                proveedorId: inputList.proveedor.value?.code,
                fechaInicio: formatearFecha(inputList.fechaInicio.value),
                fechaFin: formatearFecha(inputList.fechaFinal.value),
                xmlFile: archivoCargadoXML,
            });

            const { data, total, activate_button } = response;

            setDataTable(data || []);
            setSubtotal(total?.total_monto || 0);
            setIva(total?.total_iva || 0);
            setActivarBotonOdoo(activate_button?.activateButton || false);
            setTicketsXML(activate_button?.ticketsInXML || 0);
            setTotalMatch(activate_button?.matchTickets || 0);

        } catch (error) {
            console.error('Error al buscar tickets:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Error al buscar los tickets',
            });

            // Limpiar datos en caso de error
            setDataTable([]);
            setSubtotal(0);
            setIva(0);
            setActivarBotonOdoo(false);
            setTicketsXML(0);
            setTotalMatch(0);
        } finally {
            setIsLoadingTickets(false);
        }
    }, [inputList, archivoCargadoXML]);

    const submitInfo = useCallback(async () => {
        if (!SubmitValidation(inputList, setInputList)) return;

        if (dataTable.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Sin datos',
                text: 'No hay tickets para transferir',
            });
            return;
        }

        setIsSubmitting(true);
        try {
            const data = {
                id_proveedor: inputList.proveedor.value.code,
                fecha_compra: formatearFecha(inputList.fechaCompra.value),
                fecha_captura: formatearFecha(inputList.fechaCaptura.value),
                fecha_inicio: formatearFecha(inputList.fechaInicio.value),
                fecha_fin: formatearFecha(inputList.fechaFinal.value),
                observaciones: inputList.observaciones.value,
                total: totalMasAjuste,
                iva: iva
            };

            await subirInformacioCombustible(data);

            // Limpiar estado después del éxito
            setDataTable([]);
            setArchivoCargadoXML(null);
            setInputList(INITIAL_INPUT_LIST);
        } catch (error) {
            console.error('Error al transferir a Odoo:', error);
            // El error ya se maneja en subirInformacioCombustible
        } finally {
            setIsSubmitting(false);
        }
    }, [inputList, dataTable, totalMasAjuste, iva]);

    const submitEditarTiket = useCallback(async () => {
        if (!SubmitValidation(inputListEditarTiket, SetInputListEditarTiket)) return;

        setIsSubmitting(true);
        try {
            const data = construirPayloadTicket(inputListEditarTiket);
            await subirInfoActualizada(data, idTiket);

            SetInputListEditarTiket(INITIAL_EDITAR_TICKET);
            setOpenModalEdit(false);

            // Recargar tickets
            await buscarProveedor();

            await Swal.fire({
                icon: 'success',
                title: 'Ticket actualizado',
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            console.error('Error al editar ticket:', error);
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Error al actualizar el ticket',
            });
        } finally {
            setIsSubmitting(false);
        }
    }, [inputListEditarTiket, idTiket, buscarProveedor]);

    const agregarTicket = useCallback(async () => {
        if (!SubmitValidation(inputListAgregarTiket, SetInputListAgregarTiket)) return;

        setIsSubmitting(true);
        try {
            const data = construirPayloadTicket(inputListAgregarTiket);
            const message = await agregarTicketFunction(data);

            SetInputListAgregarTiket(INITIAL_EDITAR_TICKET);
            setOpenModalAdd(false);

            await Swal.fire({
                icon: "success",
                title: message,
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            console.error('Error al agregar ticket:', error);
            await Swal.fire({
                icon: "error",
                title: "Error",
                text: error.message || "Error al agregar el ticket",
                showConfirmButton: false,
                timer: 1500
            });
        } finally {
            setIsSubmitting(false);
        }
    }, [inputListAgregarTiket]);

    const buscarOrdenesCompra = useCallback(async () => {
        if (!SubmitValidation(inputListPurchaseOrder, setInputListPurchaseOrder)) return;

        setIsLoadingPurchaseOrders(true);
        try {
            await getPurchaseOrder(
                setPurchaseDataTable,
                formatearFecha(inputListPurchaseOrder.inicio.value) + " 00:00:00",
                formatearFecha(inputListPurchaseOrder.fin.value) + " 23:59:59"
            );
        } catch (error) {
            console.error('Error al buscar órdenes de compra:', error);
            setPurchaseDataTable([]);
        } finally {
            setIsLoadingPurchaseOrders(false);
        }
    }, [inputListPurchaseOrder]);

    const onUploadXML = useCallback((event) => {
        const file = event.files[0];

        if (!file) return;

        // Validar tipo de archivo
        if (!file.name.endsWith('.xml')) {
            Swal.fire({
                icon: 'error',
                title: 'Archivo inválido',
                text: 'Por favor, seleccione un archivo XML válido',
            });
            return;
        }

        setArchivoCargadoXML(file);
        Swal.fire({
            icon: "success",
            title: "Archivo cargado",
            text: "El archivo XML se ha cargado correctamente",
            timer: 1500,
            showConfirmButton: false
        });
    }, []);

    const handleCloseModalEdit = useCallback(() => {
        setOpenModalEdit(false);
        SetInputListEditarTiket(INITIAL_EDITAR_TICKET);
        setIdTiket(null);
    }, []);

    const handleCloseModalAdd = useCallback(() => {
        setOpenModalAdd(false);
        SetInputListAgregarTiket(INITIAL_EDITAR_TICKET);
    }, []);

    // ========================================================================
    // TEMPLATES DE COLUMNAS (Memoizados)
    // ========================================================================

    const validadoTemplate = useCallback((rowData) => (
        <div className="flex justify-content-center">
            <Checkbox checked={rowData.VALIDADO === 1} disabled />
        </div>
    ), []);

    const editarTemplate = useCallback((rowData) => (
        <Button
            icon="pi pi-pencil"
            rounded
            text
            severity="info"
            onClick={() => {
                setOpenModalEdit(true);
                setIdTiket(rowData.ID);
            }}
            disabled={isSubmitting}
        />
    ), [isSubmitting]);

    const detallesTemplate = useCallback((rowData) => (
        <Button
            icon="pi pi-eye"
            rounded
            text
            severity="help"
            onClick={() => navigate(`/administracion/ordenes-compra/${rowData.id}`)}
        />
    ), [navigate]);

    // ========================================================================
    // HEADERS DE TABLAS (Memoizados)
    // ========================================================================

    const tableHeader = useMemo(() => (
        <div className="flex justify-content-between align-items-center flex-wrap gap-2">
            <div>
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText
                        placeholder="Buscar en la tabla..."
                        value={globalFilter || ''}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        className="w-full"
                    />
                </IconField>
            </div>
            <div>
                <Button
                    label="Agregar Ticket"
                    icon="pi pi-plus"
                    onClick={() => setOpenModalAdd(true)}
                    severity="success"
                    disabled={isSubmitting}
                />
            </div>
        </div>
    ), [globalFilter, isSubmitting]);

    const purchaseTableHeader = useMemo(() => (
        <IconField iconPosition="left">
            <InputIcon className="pi pi-search" />
            <InputText
                placeholder="Buscar en la tabla..."
                value={purchaseFilter || ''}
                onChange={(e) => setPurchaseFilter(e.target.value)}
            />
        </IconField>
    ), [purchaseFilter]);

    // ========================================================================
    // RENDER
    // ========================================================================

    if (isLoadingProveedores) {
        return (
            <div className="flex justify-content-center align-items-center" style={{ height: '400px' }}>
                <ProgressSpinner />
            </div>
        );
    }

    return (
        <div className="TicketsDeGasolinaMain">
            <TabView
                className="w-full full-width-tabs"
                activeIndex={activeTab}
                onTabChange={(e) => setActiveTab(e.index)}
            >
                {/* TAB 1: TICKETS */}
                <TabPanel header="Tickets de Gasolina" leftIcon="pi pi-receipt">
                    <div className="p-fluid">
                        {/* PASO 1: Información General */}
                        <Card className="step-card mb-3">
                            <div className="step-header">
                                <Chip label="Paso 1" className="step-chip" />
                                <h3 className="step-title">Información General</h3>
                            </div>
                            <Message
                                severity="info"
                                text="Complete la información básica de la compra de combustible"
                                className="mb-3"
                            />

                            <div className="grid">
                                <div className="col-12 md:col-6">
                                    <div className="field">
                                        <label htmlFor="proveedor" className="field-label">
                                            Proveedor <span className="required">*</span>
                                        </label>
                                        <Dropdown
                                            id="proveedor"
                                            optionLabel="name"
                                            value={inputList.proveedor.value}
                                            options={proveedores}
                                            onChange={(e) => UpdateValue(e, "proveedor", inputList, setInputList)}
                                            placeholder="Seleccione el proveedor"
                                            filter
                                            filterPlaceholder="Buscar proveedor..."
                                            disabled={isLoadingTickets || isSubmitting}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 md:col-6">
                                    <div className="field">
                                        <label htmlFor="fechaCompra" className="field-label">
                                            Fecha de Compra <span className="required">*</span>
                                        </label>
                                        <Calendar
                                            id="fechaCompra"
                                            value={inputList.fechaCompra.value}
                                            onChange={(e) => UpdateValue(e, "fechaCompra", inputList, setInputList)}
                                            showIcon
                                            dateFormat="dd/mm/yy"
                                            disabled={isLoadingTickets || isSubmitting}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 md:col-4">
                                    <div className="field">
                                        <label htmlFor="fechaCaptura" className="field-label">
                                            Fecha de Captura <span className="required">*</span>
                                        </label>
                                        <Calendar
                                            id="fechaCaptura"
                                            value={inputList.fechaCaptura.value}
                                            onChange={(e) => UpdateValue(e, "fechaCaptura", inputList, setInputList)}
                                            showIcon
                                            dateFormat="dd/mm/yy"
                                            disabled={isLoadingTickets || isSubmitting}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 md:col-4">
                                    <div className="field">
                                        <label htmlFor="fechaInicio" className="field-label">
                                            Fecha de Inicio <span className="required">*</span>
                                        </label>
                                        <Calendar
                                            id="fechaInicio"
                                            value={inputList.fechaInicio.value}
                                            onChange={(e) => UpdateValue(e, "fechaInicio", inputList, setInputList)}
                                            showIcon
                                            dateFormat="dd/mm/yy"
                                            disabled={isLoadingTickets || isSubmitting}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 md:col-4">
                                    <div className="field">
                                        <label htmlFor="fechaFinal" className="field-label">
                                            Fecha de Fin <span className="required">*</span>
                                        </label>
                                        <Calendar
                                            id="fechaFinal"
                                            value={inputList.fechaFinal.value}
                                            onChange={(e) => UpdateValue(e, "fechaFinal", inputList, setInputList)}
                                            showIcon
                                            dateFormat="dd/mm/yy"
                                            disabled={isLoadingTickets || isSubmitting}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="field">
                                        <label htmlFor="observaciones" className="field-label">
                                            Observaciones <span className="required">*</span>
                                        </label>
                                        <InputTextarea
                                            id="observaciones"
                                            value={inputList.observaciones.value || ''}
                                            onChange={(e) => UpdateValue(e, "observaciones", inputList, setInputList)}
                                            placeholder="Ingrese observaciones sobre la compra..."
                                            rows={3}
                                            autoResize
                                            disabled={isLoadingTickets || isSubmitting}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Card>

                        {/* PASO 2: Cargar Archivo XML */}
                        <Card className="step-card mb-3">
                            <div className="step-header">
                                <Chip label="Paso 2" className="step-chip" />
                                <h3 className="step-title">Cargar Archivo XML</h3>
                            </div>
                            {!archivoCargadoXML && (
                                <Message
                                    severity="warn"
                                    text="Es necesario cargar el archivo XML para comparar los datos"
                                    className="mb-3"
                                />
                            )}

                            <FileUpload
                                mode="basic"
                                name="xmlFile"
                                accept=".xml"
                                maxFileSize={5000000}
                                onSelect={onUploadXML}
                                chooseLabel={archivoCargadoXML ? "Cambiar archivo XML" : "Seleccionar archivo XML"}
                                className="custom-file-upload"
                                disabled={isLoadingTickets || isSubmitting}
                            />

                            {archivoCargadoXML && (
                                <Message
                                    severity="success"
                                    text={`Archivo cargado: ${archivoCargadoXML.name}`}
                                    className="mt-2"
                                />
                            )}
                        </Card>

                        {/* PASO 3: Buscar Tickets */}
                        <Card className="step-card mb-3">
                            <div className="step-header">
                                <Chip label="Paso 3" className="step-chip" />
                                <h3 className="step-title">Buscar Tickets</h3>
                            </div>

                            <div className="flex justify-content-center">
                                <Button
                                    label={isLoadingTickets ? "Buscando..." : "Buscar Tickets"}
                                    icon={isLoadingTickets ? "pi pi-spin pi-spinner" : "pi pi-search"}
                                    onClick={buscarProveedor}
                                    className="search-button"
                                    size="large"
                                    disabled={!archivoCargadoXML || isLoadingTickets || isSubmitting}
                                    loading={isLoadingTickets}
                                />
                            </div>
                        </Card>

                        {/* RESULTADOS */}
                        {dataTable.length > 0 && (
                            <Card className="results-card mb-3">
                                <div className="results-header">
                                    <h3 className="results-title">
                                        <i className="pi pi-list"></i>
                                        Resultados de la Búsqueda
                                    </h3>
                                </div>

                                {/* Estadísticas */}
                                <div className="grid mb-3">
                                    <div className="col-12 md:col-3">
                                        <Panel className="stats-panel">
                                            <div className="stat-content">
                                                <i className="pi pi-receipt stat-icon"></i>
                                                <div className="stat-info">
                                                    <span className="stat-label">Tickets Encontrados</span>
                                                    <span className="stat-value">{dataTable.length}</span>
                                                </div>
                                            </div>
                                        </Panel>
                                    </div>
                                    <div className="col-12 md:col-3">
                                        <Panel className="stats-panel">
                                            <div className="stat-content">
                                                <i className="pi pi-file stat-icon"></i>
                                                <div className="stat-info">
                                                    <span className="stat-label">Tickets en XML</span>
                                                    <span className="stat-value">{ticketsXML}</span>
                                                </div>
                                            </div>
                                        </Panel>
                                    </div>
                                    <div className="col-12 md:col-3">
                                        <Panel className="stats-panel">
                                            <div className="stat-content">
                                                <i className="pi pi-check-circle stat-icon"></i>
                                                <div className="stat-info">
                                                    <span className="stat-label">Coincidencias</span>
                                                    <span className="stat-value">{totalMatch}</span>
                                                </div>
                                            </div>
                                        </Panel>
                                    </div>
                                    <div className="col-12 md:col-3">
                                        <Panel className="stats-panel stats-total">
                                            <div className="stat-content">
                                                <i className="pi pi-dollar stat-icon"></i>
                                                <div className="stat-info">
                                                    <span className="stat-label">Total</span>
                                                    <span className="stat-value">{FormatoMoneda(Subtotal || 0)}</span>
                                                </div>
                                            </div>
                                        </Panel>
                                    </div>
                                </div>

                                {/* Tabla de Tickets */}
                                <DataTable
                                    value={dataTable}
                                    header={tableHeader}
                                    globalFilter={globalFilter}
                                    paginator
                                    rows={20}
                                    scrollable
                                    scrollHeight="500px"
                                    stripedRows
                                    emptyMessage="No se encontraron tickets"
                                    className="custom-datatable"
                                    loading={isLoadingTickets}
                                >
                                    <Column field="VALIDADO" header="Validado" body={validadoTemplate} style={{ width: '100px' }} />
                                    <Column field="ID" header="ID" sortable style={{ width: '80px' }} />
                                    <Column field="FECHA" header="Fecha" sortable style={{ width: '120px' }} />
                                    <Column field="FOLIO_TICKET" header="Folio" sortable style={{ width: '120px' }} />
                                    <Column field="UNIDAD" header="Unidad" sortable style={{ width: '100px' }} />
                                    <Column field="OPERADOR" header="Operador" sortable style={{ width: '150px' }} />
                                    <Column field="TIPO_COMBUSTIBLE" header="Producto" sortable style={{ width: '120px' }} />
                                    <Column field="PRECIO" header="Precio" sortable style={{ width: '100px' }} />
                                    <Column field="LITROS" header="Litros" sortable style={{ width: '100px' }} />
                                    <Column field="MONTO" header="Monto" sortable style={{ width: '120px' }} />
                                    <Column header="Editar" body={editarTemplate} style={{ width: '80px' }} />
                                </DataTable>

                                <Divider />

                                <div className="flex justify-content-center">
                                    <Button
                                        label={isSubmitting ? "Transfiriendo..." : "Transferir a Odoo"}
                                        icon={isSubmitting ? "pi pi-spin pi-spinner" : "pi pi-upload"}
                                        onClick={submitInfo}
                                        className="odoo-button"
                                        size="large"
                                        disabled={!activarBotonOdoo || isSubmitting}
                                        loading={isSubmitting}
                                    />
                                </div>
                            </Card>
                        )}
                    </div>
                </TabPanel>

                {/* TAB 2: ÓRDENES DE COMPRA */}
                <TabPanel header="Órdenes de Compra" leftIcon="pi pi-shopping-cart">
                    <div className="p-fluid">
                        <Card className="filtros-card">
                            <div className="card-header">
                                <i className="pi pi-filter"></i>
                                <h3>Buscar Órdenes de Compra</h3>
                            </div>

                            <div className="grid">
                                <div className="col-12 md:col-5">
                                    <div className="field">
                                        <label htmlFor="inicio" className="field-label">
                                            Fecha de Inicio <span className="required">*</span>
                                        </label>
                                        <Calendar
                                            id="inicio"
                                            value={inputListPurchaseOrder.inicio.value}
                                            onChange={(e) => UpdateValue(e, "inicio", inputListPurchaseOrder, setInputListPurchaseOrder)}
                                            showIcon
                                            dateFormat="dd/mm/yy"
                                            disabled={isLoadingPurchaseOrders}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 md:col-5">
                                    <div className="field">
                                        <label htmlFor="fin" className="field-label">
                                            Fecha de Fin <span className="required">*</span>
                                        </label>
                                        <Calendar
                                            id="fin"
                                            value={inputListPurchaseOrder.fin.value}
                                            onChange={(e) => UpdateValue(e, "fin", inputListPurchaseOrder, setInputListPurchaseOrder)}
                                            showIcon
                                            dateFormat="dd/mm/yy"
                                            disabled={isLoadingPurchaseOrders}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 md:col-2 flex align-items-center mt-2">
                                    <Button
                                        label={isLoadingPurchaseOrders ? "Buscando..." : "Buscar"}
                                        icon={isLoadingPurchaseOrders ? "pi pi-spin pi-spinner" : "pi pi-search"}
                                        onClick={buscarOrdenesCompra}
                                        className="w-full"
                                        disabled={isLoadingPurchaseOrders}
                                        loading={isLoadingPurchaseOrders}
                                    />
                                </div>
                            </div>
                        </Card>

                        {purchaseDataTable.length > 0 && (
                            <Card className="tabla-card mt-3">
                                <DataTable
                                    value={purchaseDataTable}
                                    header={purchaseTableHeader}
                                    globalFilter={purchaseFilter}
                                    paginator
                                    rows={20}
                                    scrollable
                                    scrollHeight="500px"
                                    stripedRows
                                    emptyMessage="No se encontraron órdenes de compra"
                                    className="custom-datatable"
                                    loading={isLoadingPurchaseOrders}
                                >
                                    <Column field="id" header="ID" sortable />
                                    <Column field="folio" header="Folio" sortable />
                                    <Column field="iva" header="IVA" sortable />
                                    <Column field="subtotal" header="Subtotal" sortable />
                                    <Column field="total" header="Total" sortable />
                                    <Column field="fecha_compra" header="Fecha Compra" sortable />
                                    <Column field="fecha_inicial" header="Fecha Inicio" sortable />
                                    <Column field="fecha_final" header="Fecha Fin" sortable />
                                    <Column header="Detalles" body={detallesTemplate} />
                                </DataTable>
                            </Card>
                        )}
                    </div>
                </TabPanel>
            </TabView>

            {/* MODAL EDITAR TICKET */}
            <Dialog
                header={`Editar Ticket ID: ${idTiket}`}
                visible={openModalEdit}
                style={{ width: '90vw', maxWidth: '900px' }}
                onHide={handleCloseModalEdit}
                className="edit-dialog"
                closable={!isSubmitting}
            >
                <div className="p-fluid">
                    <div className="grid">
                        <div className="col-12 md:col-4">
                            <div className="field">
                                <label htmlFor="fecha" className="field-label">
                                    Fecha <span className="required">*</span>
                                </label>
                                <Calendar
                                    id="fecha"
                                    value={inputListEditarTiket.fecha.value}
                                    onChange={(e) => UpdateValue(e, "fecha", inputListEditarTiket, SetInputListEditarTiket)}
                                    showIcon
                                    dateFormat="dd/mm/yy"
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-4">
                            <div className="field">
                                <label htmlFor="hora" className="field-label">
                                    Hora <span className="required">*</span>
                                </label>
                                <Calendar
                                    id="hora"
                                    value={inputListEditarTiket.hora.value}
                                    onChange={(e) => UpdateValue(e, "hora", inputListEditarTiket, SetInputListEditarTiket)}
                                    timeOnly
                                    showIcon
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-4">
                            <div className="field">
                                <label htmlFor="unidad" className="field-label">
                                    Unidad <span className="required">*</span>
                                </label>
                                <InputText
                                    id="unidad"
                                    value={inputListEditarTiket.unidad.value || ''}
                                    onChange={(e) => UpdateValue(e, "unidad", inputListEditarTiket, SetInputListEditarTiket)}
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="gasolinera" className="field-label">
                                    Gasolinera <span className="required">*</span>
                                </label>
                                <Dropdown
                                    id="gasolinera"
                                    optionLabel="name"
                                    value={inputListEditarTiket.gasolinera.value}
                                    options={gasolinerasOptions}
                                    onChange={(e) => UpdateValue(e, "gasolinera", inputListEditarTiket, SetInputListEditarTiket)}
                                    placeholder="Seleccione gasolinera"
                                    filter
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="folio" className="field-label">
                                    Folio <span className="required">*</span>
                                </label>
                                <InputText
                                    id="folio"
                                    value={inputListEditarTiket.folio.value || ''}
                                    onChange={(e) => UpdateValue(e, "folio", inputListEditarTiket, SetInputListEditarTiket)}
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="kilometraje" className="field-label">
                                    Kilometraje <span className="required">*</span>
                                </label>
                                <InputText
                                    id="kilometraje"
                                    value={inputListEditarTiket.kilometraje.value || ''}
                                    onChange={(e) => UpdateValue(e, "kilometraje", inputListEditarTiket, SetInputListEditarTiket)}
                                    keyfilter="num"
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="tipoCombustible" className="field-label">
                                    Tipo de Combustible <span className="required">*</span>
                                </label>
                                <Dropdown
                                    id="tipoCombustible"
                                    optionLabel="name"
                                    value={inputListEditarTiket.tipoCombustible.value}
                                    options={TIPO_COMBUSTIBLE_OPTIONS}
                                    onChange={(e) => UpdateValue(e, "tipoCombustible", inputListEditarTiket, SetInputListEditarTiket)}
                                    placeholder="Seleccione tipo"
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="litros" className="field-label">
                                    Litros <span className="required">*</span>
                                </label>
                                <InputText
                                    id="litros"
                                    value={inputListEditarTiket.litros.value || ''}
                                    onChange={(e) => UpdateValue(e, "litros", inputListEditarTiket, SetInputListEditarTiket)}
                                    keyfilter="num"
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="precio" className="field-label">
                                    Precio <span className="required">*</span>
                                </label>
                                <InputText
                                    id="precio"
                                    value={inputListEditarTiket.precio.value || ''}
                                    onChange={(e) => UpdateValue(e, "precio", inputListEditarTiket, SetInputListEditarTiket)}
                                    keyfilter="num"
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-end gap-2 mt-3">
                        <Button
                            label="Cancelar"
                            icon="pi pi-times"
                            onClick={handleCloseModalEdit}
                            severity="secondary"
                            disabled={isSubmitting}
                        />
                        <Button
                            label={isSubmitting ? "Guardando..." : "Guardar Cambios"}
                            icon={isSubmitting ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            onClick={submitEditarTiket}
                            severity="success"
                            disabled={isSubmitting}
                            loading={isSubmitting}
                        />
                    </div>
                </div>
            </Dialog>

            {/* MODAL AGREGAR TICKET */}
            <Dialog
                header="Agregar Nuevo Ticket"
                visible={openModalAdd}
                style={{ width: '90vw', maxWidth: '900px' }}
                onHide={handleCloseModalAdd}
                className="add-dialog"
                closable={!isSubmitting}
            >
                <div className="p-fluid">
                    <div className="grid">
                        <div className="col-12 md:col-4">
                            <div className="field">
                                <label htmlFor="fecha" className="field-label">
                                    Fecha <span className="required">*</span>
                                </label>
                                <Calendar
                                    id="fecha"
                                    value={inputListAgregarTiket.fecha.value}
                                    onChange={(e) => UpdateValue(e, "fecha", inputListAgregarTiket, SetInputListAgregarTiket)}
                                    showIcon
                                    dateFormat="dd/mm/yy"
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-4">
                            <div className="field">
                                <label htmlFor="hora" className="field-label">
                                    Hora <span className="required">*</span>
                                </label>
                                <Calendar
                                    id="hora"
                                    value={inputListAgregarTiket.hora.value}
                                    onChange={(e) => UpdateValue(e, "hora", inputListAgregarTiket, SetInputListAgregarTiket)}
                                    timeOnly
                                    showIcon
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-4">
                            <div className="field">
                                <label htmlFor="unidad" className="field-label">
                                    Unidad <span className="required">*</span>
                                </label>
                                <InputText
                                    id="unidad"
                                    value={inputListAgregarTiket.unidad.value || ''}
                                    onChange={(e) => UpdateValue(e, "unidad", inputListAgregarTiket, SetInputListAgregarTiket)}
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="gasolinera" className="field-label">
                                    Gasolinera <span className="required">*</span>
                                </label>
                                <Dropdown
                                    id="gasolinera"
                                    optionLabel="name"
                                    value={inputListAgregarTiket.gasolinera.value}
                                    options={gasolinerasOptions}
                                    onChange={(e) => UpdateValue(e, "gasolinera", inputListAgregarTiket, SetInputListAgregarTiket)}
                                    placeholder="Seleccione gasolinera"
                                    filter
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="folio" className="field-label">
                                    Folio <span className="required">*</span>
                                </label>
                                <InputText
                                    id="folio"
                                    value={inputListAgregarTiket.folio.value || ''}
                                    onChange={(e) => UpdateValue(e, "folio", inputListAgregarTiket, SetInputListAgregarTiket)}
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="kilometraje" className="field-label">
                                    Kilometraje <span className="required">*</span>
                                </label>
                                <InputText
                                    id="kilometraje"
                                    value={inputListAgregarTiket.kilometraje.value || ''}
                                    onChange={(e) => UpdateValue(e, "kilometraje", inputListAgregarTiket, SetInputListAgregarTiket)}
                                    keyfilter="num"
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="tipoCombustible" className="field-label">
                                    Tipo de Combustible <span className="required">*</span>
                                </label>
                                <Dropdown
                                    id="tipoCombustible"
                                    optionLabel="name"
                                    value={inputListAgregarTiket.tipoCombustible.value}
                                    options={TIPO_COMBUSTIBLE_OPTIONS}
                                    onChange={(e) => UpdateValue(e, "tipoCombustible", inputListAgregarTiket, SetInputListAgregarTiket)}
                                    placeholder="Seleccione tipo"
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="litros" className="field-label">
                                    Litros <span className="required">*</span>
                                </label>
                                <InputText
                                    id="litros"
                                    value={inputListAgregarTiket.litros.value || ''}
                                    onChange={(e) => UpdateValue(e, "litros", inputListAgregarTiket, SetInputListAgregarTiket)}
                                    keyfilter="num"
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="field">
                                <label htmlFor="precio" className="field-label">
                                    Precio <span className="required">*</span>
                                </label>
                                <InputText
                                    id="precio"
                                    value={inputListAgregarTiket.precio.value || ''}
                                    onChange={(e) => UpdateValue(e, "precio", inputListAgregarTiket, SetInputListAgregarTiket)}
                                    keyfilter="num"
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-end gap-2 mt-3">
                        <Button
                            label="Cancelar"
                            icon="pi pi-times"
                            onClick={handleCloseModalAdd}
                            severity="secondary"
                            disabled={isSubmitting}
                        />
                        <Button
                            label={isSubmitting ? "Agregando..." : "Agregar Ticket"}
                            icon={isSubmitting ? "pi pi-spin pi-spinner" : "pi pi-plus"}
                            onClick={agregarTicket}
                            severity="success"
                            disabled={isSubmitting}
                            loading={isSubmitting}
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default TicketsDeGasolinaMain;
